import {
  call,
  put,
  select,
  takeEvery,
} from 'redux-saga/effects';
import {
  TABLE_LOAD_DATA,
} from '../actions/types/ListTableActionTypes';
import {
  tableClearData,
  tableLoadDataFailure,
  tableLoadDataSuccess,
} from '../actions/ListTableActions';
import { logoutAction } from '../../redux/actions/authActions';
import { showNotification } from '../../redux/actions/NotificationActions';
import { formatMessage } from '../../../../locales/locales';
import { languageSelector } from '../../redux/selectors/languageSelector';

function* getTableWorker(action) {
  const {
    tableDefinition,
    mainTableId,
    appContext,
    impcCodes,
    impcCode,
    transactionCode,
    dayCount,
  } = action.payload;

  const lang = yield select(languageSelector);

  try {
    yield put(tableClearData(tableDefinition));
    const result = yield call(tableDefinition.dataProvider, action.payload);
    yield put(tableLoadDataSuccess(tableDefinition, mainTableId, result.data));
  } catch (error) {
    yield put(tableLoadDataFailure(tableDefinition, mainTableId, error));
    if (error.response.status === 500 && error.response.data.message.includes('The Token has expired on')) {
      yield put(showNotification({
        type: 'ERROR',
        message: formatMessage(lang, 'app.login.message.tokenExpired'),
        duration: 20000,
      }));
      yield put(logoutAction());
    }
  }
}

function* getTableWatcher() {
  yield takeEvery(TABLE_LOAD_DATA, getTableWorker);
}

export default getTableWatcher;
export { getTableWorker };
